export default __webpack_public_path__ + "static/media/fun_jun2020_pt2.1fce71f8.bmp";